@if (loading$ | async) {
  <div class="container">
    <div class="col-8">
      @for (item of [1, 2, 3]; track item) {
        <spe-skeleton-card />
      }
    </div>
  </div>
} @else {
  <div class="container">
    <div class="col-8">
      <!-- Info Geral -->
      <div class="d-flex justify-content-between align-items-center">
        <spe-titulo-sessao titulo="Informações" [icone]="'assets/icones/cinza/document-list.svg'"> </spe-titulo-sessao>
        <span class="status-chip text-nowrap mt-48 mb-24" [ngClass]="getStatusClass(detalhes?.statusOcorrencia!)">{{
          detalhes?.statusOcorrencia
        }}</span>
      </div>

      <div class="detalhes-pedido__box-section">
        <b>Tipo de ocorrência:</b> {{ detalhes?.tipoOcorrencia }} <br />
        <b>Número:</b> {{ detalhes?.idOcorrencia }} <br />
        <b>Data de abertura:</b> {{ detalhes?.dtAbertura | date: 'dd/MM/YYYY' }} <br />
        @if (detalhes?.dtFechamento) {
          <b>Data de fechamento:</b> {{ detalhes?.dtFechamento | date: 'dd/MM/YYYY' }} <br />
        }
        <ng-container *ngIf="detalhes?.nomeResponsavel">
          <b>Responsável pela ocorrência:</b> {{ detalhes?.nomeResponsavel }} <br />
        </ng-container>
        <b>E-mail:</b> {{ detalhes?.emailResponsavel | lowercase }} <br />
        <ng-container *ngIf="detalhes?.idPedido">
          <b class="me-2">Pedido:</b>
          <a matTooltip="Abrir pedido em nova aba" href="#" (click)="goToPedido($event, detalhes?.idPedido!)"
            >{{ detalhes?.idPedido }} <mat-icon class="mat-icon-sm">open_in_new</mat-icon>
          </a>
          <br />
        </ng-container>
        <b>Origem:</b> {{ detalhes?.origemOcorrencia }} <br />
        <ng-container *ngIf="detalhes?.endCompleto && detalhes?.idTipoOcorrencia !== 2">
          <b>Endereço da entrega:</b> {{ detalhes?.endCompleto }} <br />
        </ng-container>
        <ng-container *ngIf="detalhes?.statusEncomenda && detalhes?.idTipoOcorrencia !== 2">
          <b>Status da entrega:</b> {{ detalhes?.statusEncomenda }} <br />
        </ng-container>
      </div>
      <!-- Info Beneficio -->
      <spe-titulo-sessao titulo="Produto" [icone]="'assets/icones/cinza/box.svg'"> </spe-titulo-sessao>

      <div class="detalhes-pedido__box-section">
        <ng-container *ngIf="detalhes?.nmProduto"> <b>Produto:</b> {{ detalhes?.nmProduto }} <br /> </ng-container>
        <b>Emissor:</b> {{ detalhes?.nmReduziEmissor }} <br />
        <b>Número do cartão:</b> {{ detalhes?.numeroCartao }} <br />
      </div>

      <!-- Funcionario -->
      <spe-titulo-sessao titulo="Funcionário" icone="/assets/icones/cinza/funcionarios-2.svg"></spe-titulo-sessao>

      <div class="detalhes-pedido__box-section">
        <b>Nome:</b> {{ detalhes?.nomeFuncionario }} <br />
        <b>CPF:</b> {{ detalhes?.cpfFuncionario }} <br />
        <!-- <b>RG:</b> 35322558510 <br /> -->
      </div>

      <!-- Iterações -->
      <spe-titulo-sessao
        *ngIf="detalhes?.historicoAcompanhamento?.length! > 0"
        titulo="Iterações da ocorrência"
        [icone]="'assets/icones/cinza/historico.svg'"
      ></spe-titulo-sessao>

      <div
        *ngFor="let item of detalhes?.historicoAcompanhamento"
        class="d-flex align-items-start justify-content-between gap-2 mb-16"
      >
        <div class="d-flex flex-column align-items-center pt-1 px-5">
          <h2 class="lh-1">{{ getDay(item.dtAtualizacao) }}</h2>
          <b class="font-size-16 lh-sm">{{ getMonth(item.dtAtualizacao) }}</b>
          <span class="font-size-12">{{ getYear(item.dtAtualizacao) }}</span>
        </div>
        <div class="detalhes-pedido__box-section flex-fill break-lines">{{ item.dsAcompanhamento }}</div>
      </div>
    </div>
  </div>
}
